import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { FMessage } from '../../../hoc/IntlComponents';
import { string, func, node, object, array } from 'prop-types';
import { statistics, slaves } from '../../../services/ApiService';
import { getSlaveId, isMaster } from '../statisticsHelpers';
import StaticSubIdFilter from '../StatisticsSubIdFilter/StatisticsSubIdFilter';
import {
  Button,
  PopoverBody,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  UncontrolledPopover,
} from 'reactstrap';

import { StatisticsSubIdsFiltersView } from '../index';

const defaultOption = {
  label: '—',
  value: -1,
};

class StatisticsSubIdsFilters extends PureComponent {
  static propTypes = {
    id: string,
    onFilterChange: func,
    onFilterApply: func,
    label: node,
    preselected: object,
    slavesList: array,
  };

  static defaultProps = {
    options: [],
    preselected: {},
    placement: 'auto',
    label: 'Button label',
    placeholder: 'Select...',
    slavesList: null,
  };

  constructor(props) {
    super(props);

    const { subId1, subId2, subId3, subId4, subId5 } = props.preselected;
    this.state = {
      open: false,
      data: {
        subId1: Array.isArray(subId1) ? subId1 : subId1 ? [subId1] : [],
        subId2: Array.isArray(subId2) ? subId2 : subId2 ? [subId2] : [],
        subId3: Array.isArray(subId3) ? subId3 : subId3 ? [subId3] : [],
        subId4: Array.isArray(subId4) ? subId4 : subId4 ? [subId4] : [],
        subId5: Array.isArray(subId5) ? subId5 : subId5 ? [subId5] : [],
      },
      label: '',
    };
  }

  componentDidMount() {
    const { data } = this.state;

    Promise.all([
      this.getSubIdById(1, data.subId1.filter(Number)),
      this.getSubIdById(2, data.subId2.filter(Number)),
      this.getSubIdById(3, data.subId3.filter(Number)),
      this.getSubIdById(4, data.subId4.filter(Number)),
      this.getSubIdById(5, data.subId5.filter(Number)),
    ]).then(([subId1, subId2, subId3, subId4, subId5]) => {
      this.setState((prevState) => ({
        data: { ...prevState.data, subId1, subId2, subId3, subId4, subId5 },
      }));
    });

    this.updateLabel();
  }

  getSubIdById = (subId, ids = []) => {
    if (ids.length > 0) {
      return Promise.resolve()
        .then(() => {
          const master = isMaster();
          if (master && this.props.slavesList) {
            // агрегированная статистика мастера: собираем сабы со всех баеров
            return Promise.all(
              this.props.slavesList.map(({ id: slaveId }) =>
                slaves.getSlaveSubAccounts(subId, { id: ids.join(','), slaveId }).catch(() => ({ items: [] })),
              ),
            ).then((responses) => {
              const seen = new Set();
              const items = [];
              responses.forEach(({ items: slaveItems = [] }) => {
                slaveItems.forEach((item) => {
                  if (!seen.has(item.value)) {
                    seen.add(item.value);
                    items.push(item);
                  }
                });
              });
              return [defaultOption, ...items];
            });
          }
          const req = !master ? statistics.getSubAccounts : slaves.getSlaveSubAccounts;
          const reqParams = !master
            ? [subId, { id: ids.join(',') }]
            : [subId, { id: ids.join(','), slaveId: getSlaveId() }];
          const [id, params] = reqParams;
          return req(id, params).then(({ items }) => [defaultOption, ...items]);
        });
    }

    return [];
  };

  toggle = () => {
    this.setState((prevState) => ({ open: !prevState.open }));
  };

  getValues = (subid = {}) => subid.value;

  getSelectedCount = () => {
    const { data } = this.state;
    return Object.values(data).reduce((total, subIdArray) => {
      return (
        total + (subIdArray ? subIdArray.filter((item) => item && item.value !== -1).length : 0)
      );
    }, 0);
  };

  handleSubIdChange = (values) => {
    this.setState(
      (prevState) => ({ data: { ...prevState.data, ...values } }),
      () => {
        const { data } = this.state;

        this.props.onFilterChange(
          Object.keys(data).reduce(
            (items, key) => ({ ...items, [key]: data[key].map(this.getValues) }),
            {},
          ),
        );
      },
    );
  };

  handleSubIdApply = (values) => {
    const { onFilterApply } = this.props;

    this.updateLabel();

    onFilterApply();
    this.toggle();
    setTimeout(this.toggle, 0);
  };

  handleSubIdClear = (values) => {
    const { data } = this.state;
    const { onFilterApply } = this.props;
    const result = {};

    Object.keys(data).forEach((subId) => {
      result[subId] = [];
    });

    this.setState(
      (prevState) => ({ data: { ...result } }),
      () => {
        this.props.onFilterChange(this.state.data, () => {
          onFilterApply();
          this.toggle();
          this.updateLabel();
          setTimeout(this.toggle, 0);
        });
      },
    );
  };

  updateLabel = () => {
    const { getLabel } = this.props;
    let label = getLabel ? getLabel() : '';
    const selectedCount = this.getSelectedCount();

    if (selectedCount > 0) {
      label = `${label} (${selectedCount})`;
    }

    this.setState(() => ({
      label,
    }));
  };

  render() {
    const { open, data, label } = this.state;
    const { id, placement, placeholder, disabled, counter, slavesList } = this.props;

    return (
      <StatisticsSubIdsFiltersView
        open={open}
        data={data}
        label={label}
        id={id}
        placement={placement}
        placeholder={placeholder}
        disabled={disabled}
        slavesList={slavesList}
        toggle={this.toggle}
        handleSubIdChange={this.handleSubIdChange}
        handleSubIdApply={this.handleSubIdApply}
        handleSubIdClear={this.handleSubIdClear}
        counter={counter}
      />
    );
  }
}

export default StatisticsSubIdsFilters;
